module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("My Account")]), _vm._v(" "), _c('h4', [_vm._v("Status: "), _c('span', [_vm._v(_vm._s(_vm.user && _vm.user.premium ? 'Premium' : 'Free'))])]), _vm._v(" "), (!_vm.user || !_vm.user.premium) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks!")]) : _vm._e(), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        path: '/changepassword'
      }
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "email-field"
  }, [_c('label', {
    staticClass: "email-label"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "email-input",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notifications-section"
  }, [_c('h4', {
    staticClass: "section-label"
  }, [_vm._v("Pick Notifications")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "form1"
    }
  }, [_c('div', {
    staticClass: "notify-option"
  }, [_c('label', {
    staticClass: "notify-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyEmail),
      expression: "notifyEmail"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyEmail) ? _vm._i(_vm.notifyEmail, null) > -1 : (_vm.notifyEmail)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyEmail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyEmail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox-label"
  }, [_vm._v("Email")])]), _vm._v(" "), (_vm.notifyEmail) ? _c('div', {
    staticClass: "notify-config"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }],
    staticClass: "notify-input",
    attrs: {
      "type": "text",
      "name": "contact_email_addr",
      "placeholder": "Enter Contact Email"
    },
    domProps: {
      "value": (_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notify-option"
  }, [_c('label', {
    staticClass: "notify-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyPush),
      expression: "notifyPush"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyPush) ? _vm._i(_vm.notifyPush, null) > -1 : (_vm.notifyPush)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyPush,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyPush = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyPush = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyPush = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox-label"
  }, [_vm._v("Push Notification")])]), _vm._v(" "), (_vm.notifyPush) ? _c('div', {
    staticClass: "notify-config"
  }, [_c('push-setup', {
    on: {
      "subscribed": _vm.onDeviceSubscribed
    }
  }), _vm._v(" "), (_vm.pushSaveError) ? _c('p', {
    staticClass: "push-save-error"
  }, [_vm._v(_vm._s(_vm.pushSaveError))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.user.notify_sms || _vm.user.contact_method === 2) ? _c('div', {
    staticClass: "notify-option notify-option-legacy"
  }, [_c('label', {
    staticClass: "notify-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifySms),
      expression: "notifySms"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifySms) ? _vm._i(_vm.notifySms, null) > -1 : (_vm.notifySms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifySms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifySms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifySms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifySms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox-label"
  }, [_vm._v("Text Message")]), _vm._v(" "), _c('span', {
    staticClass: "legacy-badge"
  }, [_vm._v("Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "legacy-notice"
  }, [_vm._v("Text messages are no longer available for new sign-ups. Please use Push Notifications instead.")]), _vm._v(" "), (_vm.notifySms) ? _c('div', {
    staticClass: "notify-config"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "carrier-select",
    attrs: {
      "name": "phones",
      "id": "phoneList"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.phone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.phoneOpts), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p.key))])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactPhone),
      expression: "contactPhone"
    }],
    staticClass: "notify-input",
    attrs: {
      "type": "text",
      "name": "contact_phone",
      "placeholder": "Enter Contact Phone"
    },
    domProps: {
      "value": (_vm.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactPhone = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_vm._v("Save")])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dbf5e4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyAccount.vue
// module id = 304
// module chunks = 1